import {
  converge,
  curry,
  divide,
  flip,
  map,
  multiply,
  pipe,
  prop,
  range,
} from 'ramda'
import {createEdgesFromPoints} from './common'
import line from './line'

const SEGMENTS = 36

export default function circle({x, y, r}) {
  const lineElems = createLines({x, y, r}).map(([p1, p2]) => line({
    x1: p1.x,
    y1: p1.y,
    x2: p2.x,
    y2: p2.y,
  }))

  return ({context, width, height}) => {
    return lineElems.map(fn => fn({context, width, height}))
  }
}

const getOffsetFn = (offset) => ({x, y}) => ({x: x + offset.x, y: y + offset.y})

const circleRange = map(
  pipe(flip(divide)(SEGMENTS), multiply(2 * Math.PI)),
  range(0, SEGMENTS + 1),
)

const radiusProp = prop('r')

const radiansToCoordinates = curry((r, theta) => ({
  x: r * Math.cos(theta),
  y: r * Math.sin(theta),
}))

const createCirclePointsFromRadius = pipe(
  radiansToCoordinates,
  flip(map)(circleRange),
)

const createLines = pipe(
  converge(map, [
    getOffsetFn,
    pipe(radiusProp, createCirclePointsFromRadius),
  ]),
  createEdgesFromPoints,
)

